import React, { Fragment, useEffect, useContext, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "@component/AppProvider";
import parse, { domToReact } from "html-react-parser";
import swal from "sweetalert";
import moment from "moment";
import Modal from "react-modal";
import ReactToPrint from "react-to-print";

import _API from "@util/api";
import _U from "@util/utilities";
import _DEF from "@config/defines";
import _CK from "@util/cookie";

import Editor from "@component/UI/TMEditor";

import Loading from "@component/UI/Loading";

export default () => {
    const navigate = useNavigate();
    const { site, iam } = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(true);
    const [abstract, setAbstract] = useState([]);
    const [registration, setRegistration] = useState(null);
    const [receipt, setReceipt] = useState(false);
    const [memos, setMemos] = useState([]);

    const loadData = () => {
        _API.get({ path: "/site/mypage" })
            .then((res) => {
                const { registration, abstract } = res.data;
                setAbstract(abstract);
                setRegistration(registration);
                setIsLoading(false);
            })
            .catch((e) => {
                _API.alert({ message: e.message }).then(() => {
                    navigate("/");
                });
            });
    };

    const loadConfig = () => {
        _API.get({ path: "/site/registration/config" })
            .then((res) => {
                const { memos } = res.data;
                setMemos(memos);
                setIsLoading(false);
            })
            .catch((e) => {
                _API.alert({ message: e.message }).then(() => {
                    navigate("/");
                });
            });
    };

    useEffect(() => {
        if (site?.siteCode) {
            loadData();
            if (iam) {
                if (site?.isUseRegistration === "Y") {
                    loadConfig();
                }
            }
        }
    }, [site?.siteCode, iam]);

    const getMemo = (type, field) => {
        let memo = memos.find((m) => m.type === type);

        if (!memo?.[field]) {
            return "";
        }
        if (field === "title") {
            return memo?.[field];
        } else {
            return <p dangerouslySetInnerHTML={{ __html: memo?.[field]?.replace(/\\/g, "") }}></p>;
        }
    };

    const onReceipt = () => {
        setReceipt(true);
    };

    return (
        <Fragment>
            {isLoading && <Loading />}
            <div className="contents">
                {site?.naviMypage && parse(site?.naviMypage)}

                <div className="right">
                    <div className="contentsTop">
                        <h3>Personal Information</h3>
                        <div className="location">
                            <a href="/" className="home">
                                home
                            </a>
                            <div className="loc_txt">
                                <span>Personal Information</span>
                            </div>
                        </div>
                    </div>
                    <div className="contWrap">
                        <div className="boxTable">
                            <table className="tbl_mypage">
                                <thead>
                                    <tr>
                                        <th width="33.33%">Category</th>
                                        <th width="33.33%">Review &amp; Modify</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Personal Information</td>
                                        <td>
                                            <a href="/mypage/infor" className="btn_red2">
                                                Click Here
                                            </a>
                                        </td>
                                        <td>Completed</td>
                                    </tr>
                                    {site?.isUseAbstract === "Y" && (
                                        <tr>
                                            <td>Abstract Submission</td>
                                            <td>
                                                {abstract?.map((item, index) => (
                                                    <p key={index}>
                                                        <a href={`/mypage/abstract/${item.idx}`}>
                                                            <u>{item.abstractNo}</u>
                                                        </a>
                                                    </p>
                                                ))}

                                                <p>
                                                    <a href="/abstract/regist" className="btn_red2 mt5">
                                                        New Submission
                                                    </a>
                                                </p>
                                            </td>
                                            <td>
                                                {abstract?.map((item, index) => (
                                                    <p key={index}>{_DEF.getDefinedLabel(_DEF.ABSTRACT_STATUS, item.status)}</p>
                                                ))}
                                                <p>-</p>
                                            </td>
                                        </tr>
                                    )}
                                    {site?.isUseRegistration === "Y" && (
                                        <tr>
                                            <td>Registration</td>
                                            <td>
                                                {registration ? (
                                                    <p>
                                                        <a href="/mypage/registration">{registration?.registrationNo}</a>
                                                    </p>
                                                ) : (
                                                    <span>
                                                        <a href="/registration/regist" className="btn_red2">
                                                            Go to Online Registration
                                                        </a>
                                                    </span>
                                                )}
                                            </td>
                                            <td>
                                                {registration ? (
                                                    <>
                                                        {_DEF.getDefinedLabel(_DEF.PAYMENT_STATUS, registration.payStatus)}
                                                        {registration.payStatus === "Y" && (
                                                            <div>
                                                                <a href="" onClick={onReceipt} className="btn_arr2">
                                                                    {getMemo("RECEIPT", "title") || "Receipt"}
                                                                </a>
                                                            </div>
                                                        )}
                                                    </>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {receipt && <RegistrationReceipt onClose={() => setReceipt(false)} />}
        </Fragment>
    );
};

export const RegistrationReceipt = (props) => {
    const { site, iam } = useContext(AppContext);
    const modalStyles = {
        overlay: {
            zIndex: "1001",
        },
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "-45%",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            overflowY: "auto",
        },
    };
    const [cfg, setCfg] = useState(null);
    const [options, setOptions] = useState(null);
    const [data, setData] = useState({});
    const [program, setProgram] = useState([]);
    const [template, setTemplate] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const printRef = useRef(null);

    const loadConfig = () => {
        _API.get({ path: "/site/registration/config" })
            .then((res) => {
                const { cfg, options, memos, amounts, reg, receiptTemplate } = res.data;

                setCfg(cfg);
                setOptions(options);
                setData({
                    ...reg,
                    paymentDeadline: moment().add("weeks", 2).format("YYYY-MM-DD"),
                    senderName: reg?.senderName || `${iam?.nameFirst} ${iam?.nameLast} (${reg?.registrationNo})`,
                    country: _DEF.getDefinedLabel(_DEF.COUNTRY, iam?.country),
                });
                if (reg?.program && reg?.program?.length > 0) {
                    setProgram(reg?.program);
                }
                setTemplate(receiptTemplate);
                setIsLoading(false);
            })
            .catch((e) => {
                console.log(e);
                _API.alert({ message: e.message || JSON.stringify(e) });
            });
    };

    useEffect(() => {
        if (site?.siteCode && iam) {
            loadConfig();
        }
    }, [site?.siteCode, iam]);

    const getProgramPrice = (item) => {
        let price = 0;

        if (data?.amountType === "EARLY") {
            price = iam?.country === "KR" ? item.earlyWonAmount : item.earlyUsdAmount;
        }
        if (data?.amountType === "PRE") {
            price = iam?.country === "KR" ? item.preWonAmount : item.preUsdAmount;
        }
        if (data?.amountType === "LATE") {
            price = iam?.country === "KR" ? item.lateWonAmount : item.lateUsdAmount;
        }

        return price || 0;
    };

    const getProgramStatus = (item) => {
        if (data?.program && data?.program?.length > 0) {
            const select = data?.program?.find((p) => p.programIdx === item.idx);
            return select?.value;
        }

        return "N";
    };

    useEffect(() => {
        if (template) {
            const tmp = JSON.parse(JSON.stringify(template));
            let content = tmp.content;

            content = content.replace("__REGISTRATION_NO__", data?.registrationNo);
            content = content.replace("__NAME__", `${iam?.nameFirst} ${iam?.nameLast}`);
            content = content.replace("__ORGAN__", `${iam?.metadata?.organ || ""}`);
            content = content.replace("__COUNTRY__", `${_DEF.getDefinedLabel(_DEF.COUNTRY, iam?.country)}`);
            if (data?.amountType === "EARLY") {
                content = content.replace("__CATEGORY__", `Early Registration - ${data?.categoryName}`);
            } else if (data?.amountType === "PRE") {
                content = content.replace("__CATEGORY__", `Regular Registration - ${data?.categoryName}`);
            } else if (data?.amountType === "LATE") {
                content = content.replace("__CATEGORY__", `On-site Registration - ${data?.categoryName}`);
            }

            content = content.replace("__CATEGORY_PRICE__", `${iam?.country !== "KR" ? `USD ` : ""} ${_U.addComma(data?.amount)} ${iam?.country === "KR" ? ` 원` : ""}`);
            content = content.replace("__TOTAL_PRICE__", `${iam?.country !== "KR" ? `USD ` : ""} ${_U.addComma(data?.totalAmount)} ${iam?.country === "KR" ? ` 원` : ""}`);

            let program = "";
            for (let i in options) {
                const o = options[i];
                if (getProgramStatus(o) === "Y") {
                    program += `<tr>
                    <td class="payment1" colspan="3">${o.title}</td>
                    <td class="payment2">1</td>
                    <td class="payment3">${iam?.country !== "KR" ? `USD ` : ""} ${_U.addComma(getProgramPrice(o))}  ${iam?.country === "KR" ? ` 원` : ""}</td>
                </tr>`;
                }
            }
            content = content.replace("__OPTIONS_PROGRAM__", program);
            content = content.replace("__PAYMENT_DATE__", data?.paymentDate ? moment(data?.paymentDate).format("MMMM DD, YYYY") : "");
            content = content.replace("__PAYMENT_TYPE__", data?.payType === "CARD" ? `Credit Card` : `Wire Transfer`);
            content = content.replace("__DATE__", moment().format("MMMM DD, YYYY"));

            tmp.content = content;

            setTemplate(tmp);

            setTimeout(() => {}, []);
        }
    }, [template]);

    return (
        <Modal isOpen={true} onRequestClose={props.onClose} style={modalStyles} contentLabel="Receipt">
            {isLoading && <Loading />}
            <div dangerouslySetInnerHTML={{ __html: template?.content }} ref={printRef}></div>
            <div className="btnArea1">
                <button className="btn1 btnGray1 mr2" onClick={props.onClose}>
                    Close
                </button>
                <ReactToPrint trigger={() => <button className="btn1 btnBlue1">Print</button>} content={() => printRef.current} />
            </div>
        </Modal>
    );
};
